"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

interface CleanModeWatcherProps {
  onChange: (isClean: boolean) => void;
}

// Isolated from LayoutShell so useSearchParams() only suspends this
// null-rendering leaf, not the header/children/fab/footer tree - see the
// comment in layoutShell.component.tsx for why that split matters.
export default function CleanModeWatcher({ onChange }: CleanModeWatcherProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // The whole /checkout/[shopId] flow (payment form + status page) is an
    // embedded/shared payment flow, not a marketing page - it always runs
    // without the site header/footer, regardless of the "?clean=true" param
    // some links into it already carry.
    const isCheckoutFlow = pathname?.startsWith("/checkout/");
    onChange(isCheckoutFlow || searchParams.get("clean") === "true");
  }, [pathname, searchParams, onChange]);

  return null;
}
